module.exports = __webpack_public_path__ + "img/Appa-256.e826db5c.png";